/**
 * Type definitions for Gomoku/Caro game
 */

/**
 * Represents the state of a cell on the board
 */
export enum CellState {
  EMPTY = '.',
  PLAYER_X = 'X',
  PLAYER_O = 'O',
}

/**
 * Position on the board
 */
export interface Position {
  row: number;
  col: number;
}

/**
 * Direction vector for checking lines
 */
export interface Direction {
  rowDelta: number;
  colDelta: number;
}

/**
 * Game state enumeration
 */
export enum GameState {
  PLAYING = 'PLAYING',
  PLAYER_X_WON = 'PLAYER_X_WON',
  PLAYER_O_WON = 'PLAYER_O_WON',
  DRAW = 'DRAW',
}

/**
 * Player information
 */
export interface PlayerInfo {
  name: string;
  mark: CellState.PLAYER_X | CellState.PLAYER_O;
}

/**
 * Result of a line check
 */
export interface LineCheckResult {
  count: number;
  positions: Position[];
  hasOpenStart: boolean;
  hasOpenEnd: boolean;
}

/**
 * Board configuration
 */
export interface BoardConfig {
  size: number;
  winLength: number;
  requireOpenEnd: boolean; // Vietnamese Caro rule
}
